(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["field-bag-rotation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('field-bag-rotation')) {
    customElements.define('field-bag-rotation', class extends HTMLElement {
      connectedCallback() {
        this.main = document.querySelector('[id^="MainProduct-"]');
        this.gallery = this.main?.querySelector('media-gallery');
        this.item = this.gallery?.querySelector('.product__media-item');
        this.hero = this.item?.querySelector('modal-opener .product__media img');
        const sources = [...this.querySelector('[data-frames]').content.querySelectorAll('img')];
        if (!this.hero || sources.length < 2) return;
        this.abort = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 749px)');
        this.original = this.snapshot(this.hero);
        const opener = this.item.querySelector('modal-opener');
        const mediaId = this.item.querySelector('[data-media-id]')?.dataset.mediaId;
        this.zoom = document.querySelector(opener.dataset.modal)?.querySelector(`img[data-media-id="${mediaId}"]`);
        if (this.zoom) this.originalZoom = this.snapshot(this.zoom);
        this.track = this.main.parentElement;
        this.active = 0;
        this.measure();
        this.resize = new ResizeObserver(() => { this.measure(); this.schedule(); });
        this.resize.observe(this.main);
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.images = [this.hero, ...sources.slice(1)].map(source => {
            const image = new Image();
            image.sizes = this.original.sizes || '100vw';
            image.loading = 'eager';
            image.srcset = source.getAttribute('srcset') || '';
            image.src = source.getAttribute('src');
            return image;
          });
          this.images.forEach(image => { image.sizes = this.original.sizes || '100vw'; image.loading = 'eager'; });
          Promise.all(this.images.map(image => image.decode())).then(() => {
            if (!this.isConnected) return;
            this.ready = true;
            this.track.classList.add('field-product-rotation-track');
            this.show(0);
            this.measure();
            this.schedule();
          }).catch(error => { this.dataset.loadError = error.name; this.cleanup(); });
        }, { rootMargin: '500px' });
        this.observer.observe(this.hero);
        window.addEventListener('scroll', () => this.schedule(), { passive: true, signal: this.abort.signal });
        window.addEventListener('resize', () => { this.measure(); this.schedule(); }, { signal: this.abort.signal });
        this.motion.addEventListener('change', () => { this.measure(); this.schedule(); }, { signal: this.abort.signal });
      }
      snapshot(image) {
        return Object.fromEntries(['src', 'srcset', 'sizes', 'alt'].map(key => [key, image.getAttribute(key)]));
      }
      restore(image, values) {
        for (const [key, value] of Object.entries(values)) {
          if (value === null) image.removeAttribute(key);
          else image.setAttribute(key, value);
        }
      }
      measure() {
        if (!this.track?.isConnected) return;
        this.travel = innerHeight * 1.5 * (this.mobile.matches ? Math.max(40, Math.min(80, Number(this.dataset.mobileTravel) || 60)) / 100 : 0.8);
        this.track.style.setProperty('--field-product-height', `${this.main.getBoundingClientRect().height}px`);
        this.track.style.setProperty('--field-rotation-travel', `${this.travel}px`);
        this.start = Math.max(0, scrollY + this.track.getBoundingClientRect().top - 12);
      }
      schedule() {
        if (this.pending || !this.ready) return;
        this.pending = requestAnimationFrame(() => {
          this.pending = null;
          if (this.motion.matches) { this.show(0); return; }
          const progress = Math.max(0, Math.min(1, (scrollY - this.start) / this.travel));
          this.show(Math.round(progress * (this.images.length - 1)));
        });
      }
      show(index) {
        if (!this.ready) return;
        const image = this.images[index];
        if (!image?.complete || !image.naturalWidth) return;
        if (index !== this.active) {
          if (index === 0) {
            this.restore(this.hero, this.original);
            if (this.zoom) this.restore(this.zoom, this.originalZoom);
          } else {
            this.hero.removeAttribute('srcset');
            this.hero.src = image.currentSrc || image.src;
            this.hero.alt = `${this.dataset.description}, ${index * 36}°`;
            if (this.zoom) {
              this.zoom.removeAttribute('srcset');
              this.zoom.src = image.src;
              this.zoom.alt = this.hero.alt;
            }
          }
        }
        this.hero.dataset.rotationFrame = String(index + 1);
        this.active = index;
      }
      cleanup() {
        this.ready = false;
        this.abort?.abort();
        this.observer?.disconnect();
        this.resize?.disconnect();
        if (this.pending) cancelAnimationFrame(this.pending);
        if (this.hero && this.original) { this.restore(this.hero, this.original); delete this.hero.dataset.rotationFrame; }
        if (this.zoom && this.originalZoom) this.restore(this.zoom, this.originalZoom);
        this.track?.classList.remove('field-product-rotation-track');
        this.track?.style.removeProperty('--field-product-height');
        this.track?.style.removeProperty('--field-rotation-travel');
      }
      disconnectedCallback() { this.cleanup(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["field-boxi-feature-product"]) return;
  try {
    
// Section-owned lifecycle: safe across theme editor replacement and breakpoint changes.
if (!customElements.get('field-boxi-feature')) {
 customElements.define('field-boxi-feature', class extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController();
   const signal = this.abort.signal;
   this.stage = this.querySelector('.hero-stage');
   this.track = this.querySelector('.hero-track');
   this.visual = this.querySelector('.hero-visual');
   this.scene = this.querySelector('.hero-scene');
   this.bag = this.querySelector('.bag');
   this.purchase = this.querySelector('.purchase');
   this.sticky = this.querySelector('.sticky-buy');
   this.original = {src:this.bag.src, srcset:this.bag.srcset};
   this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
   this.mobile = matchMedia('(max-width:900px), (max-width:1100px) and (orientation:landscape) and (max-height:600px)');
   this.frames = []; this.ready = false; this.loading = false; this.frame = 0;
   this.header = document.querySelector('#shopify-section-header');
   this.schedule = () => {if (!this.raf) this.raf = requestAnimationFrame(() => this.paint());};
   this.layout = () => {
    const keepProgress=this.viewportWidth && this.viewportWidth!==innerWidth && this.viewportWidth<=1100 && this.mobile.matches && this.pinnedVisible ? this.progress : null;
    if(this.viewportWidth!==innerWidth)this.style.setProperty('--stable-viewport-height',innerHeight+'px');
    this.viewportWidth=innerWidth;
    this.headerHeight = this.header?.offsetHeight || 0;
    this.style.setProperty('--header', this.headerHeight+'px');
    this.style.setProperty('--purchase-height',this.purchase.offsetHeight+'px');
    this.classList.toggle('motion-ready',this.ready && !this.reduced.matches);
    this.classList.toggle('pin-ready',this.ready && !this.reduced.matches);
    this.scrollTrack=this.mobile.matches?this.visual:this.track;
    this.pinnedStage=this.mobile.matches?this.scene:this.stage;
    this.pinTop=Math.min(0,innerHeight-this.pinnedStage.offsetHeight);
    this.style.setProperty('--pin-top',this.pinTop+'px');
    if(keepProgress!==null){
     const travel=Math.max(1,this.scrollTrack.offsetHeight-this.pinnedStage.offsetHeight);
     scrollTo({top:scrollY+this.scrollTrack.getBoundingClientRect().top-this.pinTop+keepProgress*travel,behavior:'instant'});
    }
    if (this.reduced.matches) {
     this.bag.src = this.original.src; this.bag.srcset = this.original.srcset; this.frame = 0;
    } else if (this.near) this.preload();
    this.schedule();
   };
   addEventListener('scroll',this.schedule,{passive:true,signal});
   addEventListener('resize',this.layout,{passive:true,signal});
   this.reduced.addEventListener('change',this.layout,{signal});
   this.mobile.addEventListener('change',this.layout,{signal});
   this.resize = new ResizeObserver(this.layout);
   if(this.header) this.resize.observe(this.header);
   this.resize.observe(this.purchase);
   this.resize.observe(this.scene);
   this.observer = new IntersectionObserver(entries=>{
    if(entries.some(e=>e.isIntersecting)){this.near=true;this.preload();this.observer.disconnect();}
   },{rootMargin:'300px'});
   this.observer.observe(this.stage);
   this.layout();
  }
  async preload() {
   if(this.loading||this.ready||this.reduced.matches)return;
   this.loading=true;
   try {
    const urls=JSON.parse(this.querySelector('[data-frames]').textContent);
    if(urls.length!==6)throw new Error('Six original angles are required');
    const images=urls.map(url=>{const img=new Image();img.src=this.mobile.matches?url.small:url.large;return img;});
    await Promise.all(images.map(img=>img.decode()));
    if(this.abort.signal.aborted)return;
    this.frames=images;this.ready=true;this.layout();
   } catch {
    this.ready=false;this.classList.remove('motion-ready');
   } finally {this.loading=false;}
  }
  paint() {
   this.raf=0;
   const rect=this.scrollTrack.getBoundingClientRect();
   let progress=0;
   if(this.ready&&!this.reduced.matches){
    const travel=Math.max(1,this.scrollTrack.offsetHeight-this.pinnedStage.offsetHeight);
    progress=Math.min(1,Math.max(0,(this.pinTop-rect.top)/travel));
    const next=Math.min(5,Math.round(progress*5));
    if(next!==this.frame){this.frame=next;this.bag.removeAttribute('srcset');this.bag.src=this.frames[next].src;}
   }
   const beat=Math.min(2,Math.floor(progress*3));
   this.progress=progress;
   this.pinnedVisible=this.mobile.matches && rect.top<=this.pinTop && rect.bottom>=this.pinTop+this.pinnedStage.offsetHeight;
   const sceneRect=this.scene.getBoundingClientRect();
   document.documentElement.classList.toggle('boxi-feature-chat-hidden',this.mobile.matches && sceneRect.bottom>0 && sceneRect.top<innerHeight);
   this.querySelectorAll('[data-story]').forEach((el,i)=>{el.hidden=i!==beat;});
   this.querySelector('.story-number').textContent='0'+(beat+1)+' / 03';
   this.querySelectorAll('.story-meter i').forEach((el,i)=>el.classList.toggle('active',i===beat));
   this.querySelector('[id^="frame-angle-"]').textContent=String(this.frame*36).padStart(3,'0')+'° — 180°';
   const visible=this.mobile.matches&&this.purchase.getBoundingClientRect().bottom<this.headerHeight;
   this.sticky.hidden=!visible;this.sticky.classList.toggle('is-visible',visible);
  }
  disconnectedCallback() {
   document.documentElement.classList.remove('boxi-feature-chat-hidden');
   this.abort?.abort();this.resize?.disconnect();this.observer?.disconnect();
   cancelAnimationFrame(this.raf);this.raf=0;this.classList.remove('motion-ready','pin-ready');
  }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
